import React, {useContext} from 'react';
import {Col, Layout, Row} from "antd";
import PropTypes from 'prop-types';

import './evenLayout.scss';
import {AppContext} from "../../App";

EvenLayout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

function EvenLayout(props) {
    const { children, className } = props;
    const { appSetting } = useContext(AppContext)

    const style = {
        backgroundImage: `url("${appSetting.image}")`
    }


    return (
        <Layout className='even-layout'>
            <Row className='fit-height'>
                <Col className='left-background' style={style} span={12} />
                <Col className={className} span={12}> { children }</Col>
            </Row>
        </Layout>
    )
}

export default EvenLayout;
